import ArrowDown from './assets/images/simple-arrow-down.svg'
import { IAddress, IState } from 'src/Interface'
import { format } from 'date-fns'

export const initialState: IState = {
  date: new Date(),
  modal: {
    show: false,
    type: ''
  },
  aside: {
    show: false,
    type: ''
  },
  orders: [],
  userOrders: [],
  users: [],
  branches: [],
  coordinates: [],
  companies: [],
  attributes: [],
  discountCodes: [],
  vouchers: [],
  voucherFilters: {
    customerNames: null,
    issuedByEmployees: null,
    references: null,
    toExpiryDate: null,
    fromExpiryDate: null,
    statuses: null
  },
  addresses: [],
  customAddresses: [],
  accounts: [],
  branch: {
    id: undefined,
    ordersCount: null,
    name: '',
    hexColor: '',
    status: '',
    address: {
      fullAddress: null,
      houseNo: null,
      houseLetter: null,
      streetName: null,
      poi: null,
      city: null,
      latitude: null,
      longitude: null,
      zipCode: null,
      sortOrder: null,
      label:null,
      placeType:null,
      accuracy:null
    },
    contactPerson: '',
    email: '',
  },
  company: {
    id: undefined,
    name: '',
    status: null,
    ordersCount: null,
    hexColor: '',
    address: {
      fullAddress: null,
      houseNo: null,
      houseLetter: null,
      poi: null,
      streetName: null,
      city: null,
      latitude: null,
      longitude: null,
      zipCode: null,
      sortOrder: null,
      label:null,
      placeType:null,
      accuracy:null
    },
    contactPerson: '',
    email: '',
    branches: []
  },
  isLoggedIn: true,
  user: {
    firstName: '',
    phone: null,
    branchFullAddress: '',
    id: undefined,
    email: '',
    status: undefined,
    availableAccounts: [],
    lastName: '',
    role: undefined,
    accessToken: ''
  },
  fixedTrips: [],
  bookingModule: {
    detailFields: {
      name: 'Tur detaljer',
      list: [
        {
          code: 'TI',
          description: 'Tidspunkt',
          inputLabel: 'Tid',
          defaultValue: format(new Date(), 'HH:mm'),
          type: 'time',
          name: 'time',
          category: 'DETAILS',
          modifier: 'tw-flex-1',
          required: true
        },
        {
          code: 'DA',
          name: 'date',
          type: 'date',
          defaultValue: format(new Date(), 'yyyy-MM-dd'),
          description: 'Dato',
          category: 'DETAILS',
          inputLabel: 'Dato',
          modifier: 'tw-flex-1',
          required: true,
          placeholder: '-'
        },
        {
          code: 'VO',
          name: 'numberOfPeople',
          description: 'Vogn',
          inputLabel: 'Vogn',
          type: 'dropdownInput',
          dropDownOptions: [{
            label: 'Alm. vogn (4 personer)',
            value: 4,
          },
          {
            label: 'Stor vogn (5 personer)',
            value: 5,
          },
          {
            label: 'Stor vogn (6 personer)',
            value: 6,
          },
          {
            label: 'Stor vogn (7 personer)',
            value: 7,
          },
          {
            label: 'Stor vogn (8 personer)',
            value: 8
          }],

          modifier: 'tw-flex-2',
          category: 'DETAILS',
          required: false,
          placeholder: '-',
          countryCode: '1',
          IconRight: ArrowDown
        },
        {
          code: 'AF',
          description: 'Afhentning',
          inputLabel: 'Afhentning',
          type: 'autocomplete',
          name: 'pickupAddress',
          category: 'DETAILS',
          placeholder: 'Vælg adresse',
          modifier: 'tw-flex-full',
          IconRight: ArrowDown,
          required: true
        },
        {
          code: 'DE',
          name: 'destinationAddress',
          description: 'Destination',
          type: 'autocomplete',
          category: 'DETAILS',
          placeholder: 'Vælg destination',
          IconRight: ArrowDown,
          modifier: 'tw-flex-full',
          required: false
        }
      ]
    },
    customerFields: {
      name: 'Kundeinformationer',
      list: [
        {
          code: 'FI',
          description: 'Navn',
          placeholder: 'Firma / Navn',
          name: 'customerName',
          required: false,
          category: 'CUSTOMER',
          modifier: 'tw-flex-50 tw-mr-3'
        },
        {
          code: 'TE',
          description: 'Telefon',
          name: 'customerPhone',
          required: false,
          validation: /^((\(?\+45\)?)?)(\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2})$/,
          placeholder: 'Indtast nr.',
          modifier: 'tw-flex-50',
          countryCode: '+45',
          category: 'CUSTOMER'
        },
        {
          code: 'BE',
          description: 'Betaling',
          name: 'payment',
          placeholder: '-',
          type: 'dropdown',
          category: 'CUSTOMER',
          readOnly: false,
          dropDownOptions: [{
            label: 'Konto',
            value: 'card',
            isDisabled: true
          },
          {
            label: 'I taxi',
            value: 'cash',
            isDisabled: true
          }],
          required: false,
          modifier: 'tw-flex-50'
        },
        {
          code: 'RE',
          description: 'Reference',
          category: 'CUSTOMER',
          name: 'reference',
          required: false,
          placeholder: '-',
          modifier: 'tw-flex-50'
        },
        {
          code: 'KO',
          description: 'Kommentar',
          required: false,
          placeholder: '-',
          type: 'textarea',
          name: 'comment',
          modifier: 'tw-flex-50',
          category: 'CUSTOMER'
        }
      ]
    }
  }
}

export function reducer(state: IState, action: Record<string, any>): any {
  switch (action.type) {
    case 'SET_COMPANIES':
      return {
        ...state,
        companies: action.companies
      }
    case 'SET_DATE':
      return {
        ...state,
        date: action.date
      }
    case 'SET_COORDINATES':
      return {
        ...state,
        coordinates: action.coordinates
      }
    case 'SET_BRANCHES':
      return {
        ...state,
        branches: action.branches
      }
    case 'SET_VOUCHERS':
      return {
        ...state,
        vouchers: action.vouchers,
        voucherFilters: action.filters
      }

    case 'SET_ADDRESSES':
      return {
        ...state,
        addresses: action.addresses.sort((selected:IAddress,next:IAddress)=>selected.sortOrder-next.sortOrder)
      } 
    case 'SET_CUSTOM_ADDRESSES':
      return {
        ...state,
        customAddresses: action.addresses
      }
    case 'SET_COMPANY':
      return {
        ...state,
        company: action.company
      }
    case 'SET_ORDERS':
      return {
        ...state,
        orders: action.orders
      }
    case 'SET_USER_ORDERS':
      return {
        ...state,
        userOrders: action.userOrders
      }

    case 'SET_BRANCH':
      return {
        ...state,
        branch: action.branch
      }
    case 'SET_DISCOUNT_CODES':
      return {
        ...state,
        discountCodes: action.discountCodes
      }
    case 'SET_FIXED_TRIPS':
      return {
        ...state,
        fixedTrips: action.fixedTrips.sort((selected:any,next:any)=>selected.sortOrder-next.sortOrder)
      }
    case 'SET_USER_INFO':
      return {
        ...state,
        user: action.user
      }
    case 'SET_ACCOUNTS':
      return {
        ...state,
        accounts: action.accounts
      }
    case 'SET_USERS':
      return {
        ...state,
        users: action.users
      }

    case 'SET_ATTRIBUTES': {
      return {
        ...state,
        attributes: action.attributes
      }
    }
    case 'SET_ATTRIBUTE':
      return {
        ...state,
        bookingModule: {
          ...state.bookingModule,
          [action.category]: action.list
        }
      }
    case 'SHOW_MODAL':
      return {
        ...state,
        modal: { ...action }
      }

    case 'SHOW_ASIDE':
      return {
        ...state,
        aside: { ...action }
      }
    default:
      throw new Error()
  }
}
